import React from "react";
import "./ImportList.css";
import { Import } from "../../services/import";

interface ImportListProps {
  imports: Import[];
}

const ImportList: React.FC<ImportListProps> = ({ imports }) => {
  return (
    <div className="importListContainer">
      <h2>Imports List</h2>
      <table className="importTable">
        <thead>
          <tr>
            <th>File Name</th>
            <th>Date</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {imports.map((importItem) => {
            const date = new Date(importItem.createdAt).toLocaleString();
            return (
              <React.Fragment key={importItem.id}>
                <tr className="importItem">
                  <td>{importItem.fileName}</td>
                  <td>{date}</td>
                  <td
                    className={
                      importItem.status === "running"
                        ? "statusRunning"
                        : "statusCompleted"
                    }
                  >
                    {importItem.status}
                  </td>
                </tr>
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ImportList;
